module.exports = "/static/assets/b3b57e9c1d3b49abab1d9c1d94a273a9.png";